export function getImageUrl(imagePath) {
  if (!imagePath) return '';
  if (imagePath.startsWith('http')) return imagePath;
  
  const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api/v1';
  const rootUrl = baseUrl.replace(/\/api\/v1\/?$/, '');
  
  if (imagePath.startsWith('/storage')) {
    return rootUrl + imagePath;
  }
  if (imagePath.startsWith('storage')) {
    return rootUrl + '/' + imagePath;
  }
  return rootUrl + '/storage/' + imagePath;
}
